/* Alvidon — selettore taglia stile Freiluftkind.
 *
 * Come funziona e perche' cosi':
 * - I radio veri di Dawn restano dentro <variant-selects> (nel .alv-size__list--inline),
 *   altrimenti Dawn non riesce piu' a cambiare variante.
 * - La modale viene costruita da zero e appesa a <body>. Non contiene input: ogni riga
 *   e' un <button> che rigira il click sul radio vero.
 *   Serve perche' se un antenato ha transform/filter/perspective, "position:fixed" non si
 *   ancora piu' alla finestra ma a quell'antenato: lo sfondo scuro sembra a tutto schermo
 *   mentre il pannello, centrato in una colonna alta migliaia di pixel, finisce fuori
 *   dallo schermo. Sintomo: schermo grigio e nessun pannello.
 * - Senza JS resta la lista inline, quindi la taglia e' sempre selezionabile.
 */
(function () {
  var overlay = null;   // unica modale, riusata
  var current = null;   // fieldset [data-alv-size] che l'ha aperta

  // Testo pulito di una label: Dawn ci infila dentro
  // <span class="visually-hidden label-unavailable">Variante ausverkauft oder nicht verfuegbar</span>,
  // che con textContent finirebbe nel bottone ("38Variante ausverkauft...").
  function labelText(lbl) {
    if (!lbl) return '';
    var c = lbl.cloneNode(true);
    var junk = c.querySelectorAll('.label-unavailable, .visually-hidden');
    for (var i = 0; i < junk.length; i++) junk[i].parentNode.removeChild(junk[i]);
    return c.textContent.replace(/\s+/g, ' ').trim();
  }

  function rows(sizeEl) {
    var src = sizeEl.querySelector('[data-alv-source]');
    if (!src) return [];
    var out = [];
    var inputs = src.querySelectorAll('input[type="radio"]');
    for (var i = 0; i < inputs.length; i++) {
      var inp = inputs[i];
      var lbl = src.querySelector('label[for="' + inp.id + '"]');
      out.push({
        input: inp,
        text: labelText(lbl) || inp.value,
        disabled: inp.disabled || inp.classList.contains('disabled'),
        checked: inp.checked
      });
    }
    return out;
  }

  function buildOverlay() {
    if (overlay) return overlay;
    overlay = document.createElement('div');
    overlay.className = 'alv-size__overlay';
    overlay.hidden = true;
    overlay.innerHTML =
      '<div class="alv-size__panel" role="dialog" aria-modal="true">' +
        '<div class="alv-size__bar"><span data-alv-title></span>' +
          '<button type="button" class="alv-size__x" data-alv-close aria-label="Schließen">&times;</button>' +
        '</div>' +
        '<div class="alv-size__list" data-alv-rows></div>' +
      '</div>';
    document.body.appendChild(overlay);
    return overlay;
  }

  function open(sizeEl) {
    var list = rows(sizeEl);
    if (!list.length) return false;          // niente taglie: non aprire una modale vuota
    var ov = buildOverlay();
    current = sizeEl;
    ov.querySelector('[data-alv-title]').textContent = sizeEl.getAttribute('data-alv-label') || '';
    var box = ov.querySelector('[data-alv-rows]');
    box.innerHTML = '';
    list.forEach(function (r, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'alv-row' + (r.disabled ? ' is-disabled' : '') + (r.checked ? ' is-checked' : '');
      b.textContent = r.text;
      b.setAttribute('data-alv-i', String(i));
      if (r.disabled) b.setAttribute('aria-disabled', 'true');
      box.appendChild(b);
    });
    ov.__rows = list;
    ov.hidden = false;
    document.body.classList.add('alv-modal-open');
    var sel = box.querySelector('.is-checked');
    if (sel && sel.scrollIntoView) sel.scrollIntoView({ block: 'center' });
    return true;
  }

  function close() {
    if (overlay) overlay.hidden = true;
    document.body.classList.remove('alv-modal-open');
  }

  function syncTrigger(sizeEl) {
    var t = sizeEl.querySelector('[data-alv-trigger-text]');
    var src = sizeEl.querySelector('[data-alv-source]');
    if (!t || !src) return;
    var checked = src.querySelector('input[type="radio"]:checked');
    if (!checked) return;
    var lbl = src.querySelector('label[for="' + checked.id + '"]');
    var val = labelText(lbl) || checked.value;
    if (t.textContent !== val) t.textContent = val;
    // Il blocco "nessuna taglia preselezionata" scrive "Größe wählen" dentro
    // [data-selected-value]: una volta scelta la taglia va rimesso il numero,
    // altrimenti l'intestazione resta "Größe: Größe wählen" per sempre.
    // Il confronto prima di scrivere evita di risvegliare gli observer.
    var head = sizeEl.querySelector('[data-selected-value]');
    if (head && head.textContent !== val) head.textContent = val;
  }

  // Attiva la modalita' JS: nasconde la lista inline, mostra il bottone.
  function activate(sizeEl) {
    if (!rows(sizeEl).length) return;        // nessuna taglia: lascia la lista inline
    sizeEl.classList.add('alv-size--js');
    var t = sizeEl.querySelector('[data-alv-trigger-text]');
    var btn = sizeEl.querySelector('[data-alv-open]');
    if (btn) btn.hidden = false;
    if (t) syncTrigger(sizeEl);
  }

  function activateAll(root) {
    var els = (root || document).querySelectorAll('[data-alv-size]');
    for (var i = 0; i < els.length; i++) activate(els[i]);
  }

  document.addEventListener('click', function (e) {
    var trg = e.target.closest ? e.target.closest('[data-alv-open]') : null;
    if (trg) { open(trg.closest('[data-alv-size]')); return; }

    if (e.target.closest && e.target.closest('[data-alv-close]')) { close(); return; }

    if (overlay && e.target === overlay) { close(); return; }

    var row = e.target.closest ? e.target.closest('.alv-row') : null;
    if (row && overlay && overlay.__rows) {
      var r = overlay.__rows[parseInt(row.getAttribute('data-alv-i'), 10)];
      if (!r || r.disabled) return;          // taglia esaurita: non selezionabile
      close();
      r.input.click();                       // click sul radio VERO: Dawn fa il resto
      if (current) syncTrigger(current);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });

  // Dawn ricostruisce il picker a ogni cambio variante: riattiva e richiudi.
  document.addEventListener('change', function (e) {
    var s = e.target.closest ? e.target.closest('[data-alv-size]') : null;
    if (s) syncTrigger(s);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { activateAll(); });
  } else {
    activateAll();
  }

  // Dawn rimpiazza il markup del picker dopo un cambio variante: bisogna riattivare.
  // Si osserva solo la sezione prodotto, non tutta la pagina, e con un debounce,
  // altrimenti su una scheda prodotto piena di app si richiama a ogni singola modifica.
  if (window.MutationObserver) {
    var pending = null;
    var obs = new MutationObserver(function () {
      if (pending) return;
      pending = setTimeout(function () { pending = null; activateAll(); }, 100);
    });
    var scope = document.querySelector('.product, main') || document.body;
    obs.observe(scope, { childList: true, subtree: true });
  }
})();

/* ============================================================
   Swatch colore sulla card prodotto (stile Freiluftkind):
   cliccando il pallino cambia la foto della card, NON apre il prodotto.
   ============================================================ */
(function () {
  function cardImage(fieldset) {
    var card = fieldset.closest('.card-wrapper') || fieldset.closest('.card');
    if (!card) return null;
    return card.querySelector('.card__media img, .card__inner .media img, img.motion-reduce');
  }

  function onChange(event) {
    var input = event.target;
    if (!input.classList || !input.classList.contains('alv-card-swatch__input')) return;
    var fieldset = input.closest('.alv-card-swatches');
    if (!fieldset) return;

    var src = input.dataset.variantImage;
    if (src) {
      var img = cardImage(fieldset);
      if (img) {
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
        img.src = src;
      }
    }

    // il link della card punta alla variante scelta
    var variantId = input.dataset.variantId;
    if (variantId) {
      var card = fieldset.closest('.card-wrapper') || fieldset.closest('.card');
      if (card) {
        card.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
          a.href = a.href.split('?')[0] + '?variant=' + variantId;
        });
      }
    }
  }

  // il pallino non deve mai far scattare la navigazione della card
  function stopNav(event) {
    if (event.target.closest && event.target.closest('.alv-card-swatches')) {
      event.stopPropagation();
    }
  }

  document.addEventListener('change', onChange);
  document.addEventListener('click', stopNav, true);
})();

/* ============================================================
   Badge sconto in alto a sinistra, sempre.
   Il badge nasce dentro .card__content (che il tema tiene
   position:relative), quindi "top:8px" cadeva a meta' foto.
   Lo spostiamo dentro .card__inner, cioe' il riquadro immagine.
   ============================================================ */
(function () {
  function moveBadges(scope) {
    (scope || document).querySelectorAll('.card__badge.alv-badge-list').forEach(function (badge) {
      var card = badge.closest('.card-wrapper') || badge.closest('.card');
      if (!card) return;
      var target = card.querySelector('.card__inner') || card;
      if (badge.parentElement === target) return;
      if (getComputedStyle(target).position === 'static') target.style.position = 'relative';
      target.appendChild(badge);
      badge.style.position = 'absolute';
      badge.style.top = '8px';
      badge.style.left = '8px';
      badge.style.right = 'auto';
      badge.style.bottom = 'auto';
      badge.style.zIndex = '5';
    });
  }

  function init() { moveBadges(document); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // le griglie filtrate/paginated ricaricano le card via AJAX
  // Osserva solo il contenuto principale, non l'intero documento, e accorpa le
  // chiamate con un debounce: con Kaching/Judge.me/Klaviyo che toccano il DOM di
  // continuo, osservare documentElement costava ~500 ms di CPU (PageSpeed 25 ago).
  var bPending = null, bQueue = [];
  new MutationObserver(function (muts) {
    muts.forEach(function (m) {
      m.addedNodes.forEach(function (n) {
        if (n.nodeType === 1) bQueue.push(n.matches && n.matches('.card-wrapper') ? n.parentElement : n);
      });
    });
    if (bPending) return;
    bPending = setTimeout(function () {
      bPending = null;
      var q = bQueue; bQueue = [];
      q.forEach(function (n) { if (n) moveBadges(n); });
    }, 100);
  }).observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true });
})();

/* Alvidon - nessuna taglia preselezionata.
Shopify preseleziona sempre la prima variante (la taglia piu' piccola).
Qui la taglia parte vuota e "In den Warenkorb" resta bloccato finche' il cliente non ne sceglie una.
Il radio del form NON viene toccato nella sostanza: la variante viaggia nell'input hidden name="id",
quindi togliere la spunta e' solo visivo e non rompe Dawn ne' il bundle Kaching. */
(function () {
var PICK = 'Größe wählen';
var WAIT = 'Bitte Größe wählen';
var chosen = false;
function apply() {
if (chosen) return;
var fs = document.querySelector('.alv-size');
if (!fs) return;
var head = fs.querySelector('[data-selected-value]');
var trig = fs.querySelector('[data-alv-trigger-text]');
// ATTENZIONE: scrivere textContent sostituisce il nodo di testo e conta come
// modifica del DOM. Siccome qui sotto c'e' un MutationObserver che richiama
// apply(), scrivere SEMPRE creava un ciclo infinito che bloccava la scheda
// prodotto. Si scrive solo se il valore e' davvero diverso.
// L'intestazione resta vuota finché non si sceglie: scriverci "Größe wählen"
// dava "Größe: Größe wählen" con il bottone sotto che ripeteva la stessa frase.
// L'invito a scegliere lo dà il bottone, non l'etichetta.
if (head && head.textContent !== '') head.textContent = '';
if (trig && trig.textContent !== PICK) trig.textContent = PICK;
var radios = fs.querySelectorAll('input[type="radio"]');
for (var i = 0; i < radios.length; i++) if (radios[i].checked) radios[i].checked = false;
var btn = document.querySelector('.product-form__submit');
if (!btn || btn.hasAttribute('data-alv-cta')) return;
var span = btn.querySelector('span') || btn;
btn.setAttribute('data-alv-cta', span.textContent);
span.textContent = WAIT;
btn.setAttribute('disabled', 'disabled');
}
function release() {
chosen = true;
var btn = document.querySelector('.product-form__submit');
if (!btn || !btn.hasAttribute('data-alv-cta')) return;
var span = btn.querySelector('span') || btn;
span.textContent = btn.getAttribute('data-alv-cta');
btn.removeAttribute('data-alv-cta');
btn.removeAttribute('disabled');
}
document.addEventListener('change', function (e) {
var t = e.target;
if (!t || !t.closest) return;
if (t.type === 'radio' && t.closest('.alv-size')) release();
if (t.tagName === 'SELECT' && t.closest('.product__info-container')) release();
}, true);
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply);
else apply();
// Doppia sicurezza: l'observer si stacca mentre apply() lavora e si riattacca
// dopo, e le raffiche di mutazioni vengono accorpate in un solo giro.
var obs, pending = false;
function run() {
  pending = false;
  if (obs) obs.disconnect();
  apply();
  if (obs && !chosen) obs.observe(document.querySelector('.product') || document.getElementById('MainContent') || document.documentElement, { childList: true, subtree: true });
}
obs = new MutationObserver(function () {
  if (pending) return;
  pending = true;
  requestAnimationFrame(run);
});
// I radio delle taglie stanno dentro la scheda prodotto: osservare l'intero
// documento faceva ripartire questa funzione a ogni modifica di qualsiasi app.
obs.observe(document.querySelector('.product') || document.getElementById('MainContent') || document.documentElement, { childList: true, subtree: true });
})();

/* ------------------------------------------------------------------
   Rete di sicurezza. Il CSS nasconde subito la lista taglie e mostra il
   pulsante (serve a evitare il CLS). Se per qualsiasi motivo la modalita'
   JS non si attiva, senza questo controllo il cliente non potrebbe piu
   scegliere la taglia: la lista tornerebbe invisibile e il pulsante inerte.
   Dopo 3 secondi, ogni blocco taglie non attivato torna alla lista inline.
   ------------------------------------------------------------------ */
setTimeout(function () {
  document.querySelectorAll('.alv-size').forEach(function (el) {
    if (el.classList.contains('alv-size--js')) return;   // attivato: tutto ok
    var lista = el.querySelector('.alv-size__list--inline');
    var btn = el.querySelector('[data-alv-open]');
    if (lista) lista.style.display = 'block';
    if (btn) btn.style.display = 'none';
  });
}, 3000);

/* ==================================================================
   PRIMO SCHERMO MOBILE - ordine stile HIKE Footwear (29 ago 2026)
   Corso Antichi mod. 8.2 (12.5 prezzo visibile, 12.6 recensioni in alto).

   Nell'HTML la galleria (.product__media-wrapper) sta PRIMA del blocco
   info: su mobile spinge titolo, prezzo e recensioni sotto la piega.
   Qui, sotto i 750px, sposto fisicamente nel DOM i blocchi che devono
   stare sopra la foto. Niente display:contents (rompeva lo sticky della
   galleria e la foto si sovrapponeva ai testi).
   Desktop: non viene toccato nulla.
   ------------------------------------------------------------------ */
(function () {
  var MOBILE = window.matchMedia('(max-width: 749px)');
  var SOPRA = ['.alv-orig', '.alv-exp', '.product__title', '.alv-price-row',
               '.alv-delivery-line', '.product__tax', '.shopify-app-block'];
  var fatto = false;

  function riordina() {
    if (fatto || !MOBILE.matches) return;
    var prodotto = document.querySelector('.product');
    var media = document.querySelector('.product__media-wrapper');
    var info = document.querySelector('.product__info-container');
    if (!prodotto || !media || !info) return;

    var cassetto = document.createElement('div');
    cassetto.className = 'alv-primo-schermo';
    SOPRA.forEach(function (sel) {
      var el = info.querySelector(':scope > ' + sel);
      if (el) cassetto.appendChild(el);
    });
    if (!cassetto.children.length) return;
    prodotto.insertBefore(cassetto, media);
    fatto = true;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', riordina);
  } else {
    riordina();
  }
})();
